import {isBiologicsEnabled} from 'antibodies/util/biologicsCapability';
import BenchlingConfig from 'BenchlingConfig';

/** Mirrors is_domain_sequence_annotation_enabled in annotate_domain_sequences_access.py. */
export default function isDomainSequenceAnnotationEnabled(): boolean {
  return isBiologicsEnabled() && BenchlingConfig.ANTIBODY_ENABLE_DOMAIN_SEQUENCE_ANNOTATION;
}
